import { useTranslation } from 'react-i18next';

export function SpeciesSelectorIntro() {
  const { t } = useTranslation('matching');
  return (
    <div className='text-center lg:text-left'>
      <h1 className='font-heading text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-4xl'>
        {t('species.headingStart')}{' '}
        <span className='text-primary-600'>
          {t('species.headingHighlight')}
        </span>{' '}
        {t('species.headingEnd')}
      </h1>
      <p className='mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg'>
        {t('species.intro')}
      </p>
    </div>
  );
}
